import React from 'react'
import { hotelFacilities } from '../../../../../config/generatedConfig'
import { object, string } from 'prop-types'

class HotelFacilitiesTable extends React.Component {
  generateTableInnerHTML () {
    const { productData: product = {} } = this.props
    return hotelFacilities.reduce((rows, obj, index) => {
      if (product.hasOwnProperty(obj.key)) {
        let cellContent = false
        if (obj.type === 'yn') {
          cellContent = product[obj.key].toString() === '1' ? <i className='fa fa-check' /> : <i className='fa fa-times' />
        } else if (obj.type === 'html' && product.hasOwnProperty(obj.key) && product[obj.key].toString().trim().length) {
          cellContent = product[obj.key]
        } else if (obj.type === 'stars') {
          const starsNumber = Number(product[obj.key])
          if (starsNumber > 0) {
            cellContent = []
            for (let i = 1; i <= starsNumber; i++) {
              cellContent.push(<i key={i} className='fa fa-star' />)
            }
          }
        }
        if (cellContent !== false) {
          rows.push(
            <tr key={index}>
              <td>{ obj.label }</td>
              { obj.type === 'html' && <td dangerouslySetInnerHTML={{ __html: cellContent }} /> }
              { obj.type !== 'html' && <td>{ cellContent }</td> }
            </tr>
          )
        }
      }
      return rows
    }, [])
  }

  render () {
    const { productName } = this.props
    const facilities = this.generateTableInnerHTML()

    if (!facilities.length) {
      return null
    }

    return (
      <div>
        { (typeof productName === 'string' && productName.length > 0)
            ? <h2>{ productName } Additional Information</h2>
            : <h2>Additional Information</h2>
        }
        <table className='table table-striped hotelFacilitiesTable'>
          <tbody>{ facilities }</tbody>
        </table>
      </div>
    )
  }
}

HotelFacilitiesTable.propTypes = {
  productData: object.isRequired,
  productName: string
}

HotelFacilitiesTable.defaultProps = {
  productData: { }
}

export default HotelFacilitiesTable



// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/specificProduct/hotelFacilitiesTable.jsx